module.exports = __webpack_public_path__ + "img/q.05c6bf72.png";